import { css } from 'linaria';

export namespace Styles {
  export const stickyPanelWrapper = css`
    position: sticky;
    position: -webkit-sticky;
    display: flex;
    justify-content: center;
    height: var(--pdp-sticky-panel-height, 64px);
    background-color: var(--background-primary);
  `;

  export const stickyPanelTabletWrapper = css`
    position: relative;
    display: flex;
    justify-content: center;
    height: var(--pdp-sticky-panel-height, 64px);
    background-color: var(--background-primary);
  `;

  export const stickyPanelInnerWrapper = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    &.mobile {
      width: 100%;
    }

    &.tablet {
      width: 100%;
    }

    &.medium {
      width: 940px;
    }

    &.large {
      width: 1180px;
    }
  `;

  export const mobileProductWrapper = css`
    display: block;
    width: 100%;
  `;

  export const tabletProductWrapper = css`
    display: block;
    width: 100%;
  `;

  export const mediumPlusScreenProductWrapper = css`
    display: block;
    min-width: 239px;
  `;

  export const fullSize = css`
    width: 100%;
    height: 100%;
  `;

  export const hidden = css`
    display: none;
  `;

  export const invisible = css`
    height: 0;
    visibility: hidden;
  `;
}
